// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HI-z","modalContent":"II-z","header":"JI-z","close":"KI-z"};